// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* (Keep the rest of your existing CSS below this) */
/* 🔐 Full-width Hero Banner */
.cyber-hero-banner {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
/* Hero Section Container */
.cyber-hero-banner {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
}

/* Background Image */
.hero-bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* Overlay Text Container (No Background Now) */
.hero-overlay {
  position: absolute;
  inset: 0;
 
  display: flex;
  align-items: center;
  padding-left: 60px;
  color: #fff;
}

/* Text Wrapper */
.hero-text {
  max-width: 600px;
}

.hero-text h1 {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 1.4;
    color: #155a11;
}

.hero-text p {
  font-size: 16px;
  line-height: 1.6;
  color: #155a11;
}


/* Feature Section */
.cyber-feature {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 80px;
  padding: 60px 20px;
  max-width: 1200px;
  margin: auto;
  align-items: center;
}
.cyber-feature-left img {
  margin-top: 20px;
  margin-bottom: 30px;
  width: 280px;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 4px solid #ffffff;
  background-color: #fff;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.cyber-feature-left img:hover {
  transform: scale(1.03);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
}


.stat-text {
  margin-top: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #2F4D38;
}

.cyber-feature-right {
  
  flex: 2 1;
}

.cyber-feature-right h2 {
  font-size: 28px;
  font-weight: bold;
  color: #2F4D38;
  margin-bottom: 12px;
}

.cyber-feature-right p {
  color: #444;
  margin-bottom: 12px;
  line-height: 1.7;
}

/* Topics Grid */
.cyber-topics-grid {
  background-color: #f0f4f3;
  padding: 40px;
  border-radius: 16px;
  margin: 40px auto;
  max-width: 1200px;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}

.cyber-topics-grid h4 {
  font-weight: bold;
  margin-bottom: 10px;
  color: #2F4D38;
}

.cyber-topics-grid ul {
  padding-left: 20px;
  color: #444;
}

.cyber-topics-grid li {
  margin-bottom: 8px;
  font-size: 15px;
}

/* Text Blocks */
.cyber-text-blocks {
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.text-block {
  margin-bottom: 40px;
}

.text-block h3 {
  font-size: 22px;
  color: #2F4D38;
  margin-bottom: 10px;
}

.text-block p {
  color: #444;
  line-height: 1.6;
}

/* Benefits */
.cyber-benefits {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  padding: 60px 20px;
  max-width: 1200px;
  margin: auto;
  align-items: center;
}

.benefits-left {
  flex: 1 1;
}

.benefits-left h3 {
  font-size: 22px;
  color: #2F4D38;
  margin-bottom: 16px;
}

.benefits-left ul {
  padding-left: 20px;
  color: #444;
}

.benefits-left li {
  margin-bottom: 10px;
  font-size: 15px;
}

.benefits-right {
  flex: 1 1;
  text-align: center;
}

.benefits-right img {
  max-width: 260px;
}

.breach-stat {
  margin-top: 10px;
  font-size: 14px;
  color: #2F4D38;
  font-weight: bold;
}

/* CTA */
.cyber-cta {
  text-align: center;
  /* margin: 60px 0; */
  background-color: #1f6740;
  padding: 50px;
}

.cyber-cta h4 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: white;
}

.cyber-cta button {
 background-color: #1f6740;
  color: white;
  padding: 12px 28px;
  border-radius: 9999px;
  font-weight: 600;
  border: white 1px solid;
  cursor: pointer;
  transition: background 0.3s ease;
}

.cyber-cta button:hover {
  background-color: #25402d;
}
.cyber-topics-grid-section {
  background-color: #224D36; /* Deep green */
  padding: 60px 20px;
  color: white;
  text-align: center;
}

.topics-heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
}

.topics-columns {
  display: flex;
  justify-content: center;
  gap: 60px;
  flex-wrap: wrap;
}

.topics-columns ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.topics-columns li {
  margin-bottom: 12px;
  position: relative;
  padding-left: 24px;
}

.topics-columns li::before {
  content: "✔";
  position: absolute;
  left: 0;
  color: #A1F0DC; /* Light green icon */
  font-size: 14px;
}
.cyber-topics-grid-section {
  background-color: #ffffff;
  color: rgb(17, 17, 17);
  padding: 60px 20px;
  text-align: center;
}

.topics-heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
}

.topics-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 👈 Four equal-width columns */
  gap: 20px;
  max-width: 1400px;
  margin: 0 auto;
  text-align: left;
}

.topic-item {
  background-color: rgba(120, 196, 120, 0.05);
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  height: 100px;
  align-items: center;
  gap: 10px;
  font-size: 15px;
}

.check-icon {
  color: #A1F0DC;
  font-size: 16px;
}
.topic-item {
  background-color: rgba(120, 196, 120, 0.05);
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  height: 100px;
  gap: 12px;
  font-size: 16px;
  transition: background 0.3s ease;
}

.topic-item:hover {
  background-color: rgba(47, 77, 56, 0.1);
}

.check-icon {
  font-size: 30px;
  flex-shrink: 0;
}


.cyber-learning-compliance {
  background-color: #fff;
  padding:40px;
  /* max-width: 1100px; */
  /* margin: 0 auto; */
}

.learning-block {
  background-color: #f5fdfb;
  border-left: 6px solid #2F4D38;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 40px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.learning-block h3 {
  font-size: 22px;
  color: #2F4D38;
  margin-bottom: 15px;
  font-weight: 600;
}

.learning-block p {
  color: #333;
  font-size: 15px;
  line-height: 1.7;
}
.cyber-benefits-redesign {
  background-color: #f9fdfb;
  padding: 60px 20px;
}

.benefits-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
}

.benefits-list {
  flex: 1 1;
}

.benefits-list h3 {
  font-size: 24px;
  color: #2F4D38;
  margin-bottom: 24px;
}

.benefit-items {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

.benefit-card {
  background: #ffffff;
  border-left: 5px solid #2F4D38;
  padding: 14px 18px;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.benefit-icon {
  color: #2F4D38;
  font-weight: bold;
  font-size: 16px;
  margin-top: 2px;
}

.benefit-card p {
  margin: 0;
  color: #333;
  font-size: 15px;
}

.benefits-image {
  flex: 1 1;
  text-align: center;
}

.benefits-image img {
  max-width: 300px;
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.breach-highlight {
  background-color: #e6f5f0;
  color: #1c3c2e;
  padding: 12px 16px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 15px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
}

/* Bottom CTA */
.bottom-cta {
  background-color: #2F4D38;
  color: white;
  text-align: center;
  padding: 4rem 1rem;
}

.bottom-cta .cta-container {
  max-width: 40rem;
  margin: 0 auto;
}

.bottom-cta h3 {
  font-size: 1.25rem;
  font-weight: 500;
}

.bottom-cta p {
  font-size: 1.125rem;
  margin: 1rem 0;
}

.bottom-cta button {
  background-color: white;
  color: #2F4D38;
  padding: 0.5rem 1.5rem;
  font-weight: 500;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.bottom-cta button:hover {
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/pages/CyberSecuritySection.css"],"names":[],"mappings":";AACA,oDAAoD;AACpD,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;AACA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,QAAQ;;EAER,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;IACd,cAAc;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;CACC,yBAAyB;EACxB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc,EAAE,qBAAqB;EACrC,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,gCAAgC;EACvE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;;AAGA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["\r\n/* (Keep the rest of your existing CSS below this) */\r\n/* 🔐 Full-width Hero Banner */\r\n.cyber-hero-banner {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 400px;\r\n  overflow: hidden;\r\n}\r\n\r\n.hero-bg-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n/* Hero Section Container */\r\n.cyber-hero-banner {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 400px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Background Image */\r\n.hero-bg-img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n/* Overlay Text Container (No Background Now) */\r\n.hero-overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n \r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 60px;\r\n  color: #fff;\r\n}\r\n\r\n/* Text Wrapper */\r\n.hero-text {\r\n  max-width: 600px;\r\n}\r\n\r\n.hero-text h1 {\r\n  font-size: 36px;\r\n  font-weight: 700;\r\n  margin-bottom: 16px;\r\n  line-height: 1.4;\r\n    color: #155a11;\r\n}\r\n\r\n.hero-text p {\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n  color: #155a11;\r\n}\r\n\r\n\r\n/* Feature Section */\r\n.cyber-feature {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  gap: 80px;\r\n  padding: 60px 20px;\r\n  max-width: 1200px;\r\n  margin: auto;\r\n  align-items: center;\r\n}\r\n.cyber-feature-left img {\r\n  margin-top: 20px;\r\n  margin-bottom: 30px;\r\n  width: 280px;\r\n  height: auto;\r\n  border-radius: 16px;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\r\n  border: 4px solid #ffffff;\r\n  background-color: #fff;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.cyber-feature-left img:hover {\r\n  transform: scale(1.03);\r\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n\r\n.stat-text {\r\n  margin-top: 12px;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #2F4D38;\r\n}\r\n\r\n.cyber-feature-right {\r\n  \r\n  flex: 2;\r\n}\r\n\r\n.cyber-feature-right h2 {\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  color: #2F4D38;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.cyber-feature-right p {\r\n  color: #444;\r\n  margin-bottom: 12px;\r\n  line-height: 1.7;\r\n}\r\n\r\n/* Topics Grid */\r\n.cyber-topics-grid {\r\n  background-color: #f0f4f3;\r\n  padding: 40px;\r\n  border-radius: 16px;\r\n  margin: 40px auto;\r\n  max-width: 1200px;\r\n  display: grid;\r\n  gap: 30px;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n}\r\n\r\n.cyber-topics-grid h4 {\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n  color: #2F4D38;\r\n}\r\n\r\n.cyber-topics-grid ul {\r\n  padding-left: 20px;\r\n  color: #444;\r\n}\r\n\r\n.cyber-topics-grid li {\r\n  margin-bottom: 8px;\r\n  font-size: 15px;\r\n}\r\n\r\n/* Text Blocks */\r\n.cyber-text-blocks {\r\n  max-width: 1200px;\r\n  margin: 60px auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n.text-block {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.text-block h3 {\r\n  font-size: 22px;\r\n  color: #2F4D38;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.text-block p {\r\n  color: #444;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Benefits */\r\n.cyber-benefits {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  gap: 40px;\r\n  padding: 60px 20px;\r\n  max-width: 1200px;\r\n  margin: auto;\r\n  align-items: center;\r\n}\r\n\r\n.benefits-left {\r\n  flex: 1;\r\n}\r\n\r\n.benefits-left h3 {\r\n  font-size: 22px;\r\n  color: #2F4D38;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.benefits-left ul {\r\n  padding-left: 20px;\r\n  color: #444;\r\n}\r\n\r\n.benefits-left li {\r\n  margin-bottom: 10px;\r\n  font-size: 15px;\r\n}\r\n\r\n.benefits-right {\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.benefits-right img {\r\n  max-width: 260px;\r\n}\r\n\r\n.breach-stat {\r\n  margin-top: 10px;\r\n  font-size: 14px;\r\n  color: #2F4D38;\r\n  font-weight: bold;\r\n}\r\n\r\n/* CTA */\r\n.cyber-cta {\r\n  text-align: center;\r\n  /* margin: 60px 0; */\r\n  background-color: #1f6740;\r\n  padding: 50px;\r\n}\r\n\r\n.cyber-cta h4 {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 20px;\r\n  color: white;\r\n}\r\n\r\n.cyber-cta button {\r\n background-color: #1f6740;\r\n  color: white;\r\n  padding: 12px 28px;\r\n  border-radius: 9999px;\r\n  font-weight: 600;\r\n  border: white 1px solid;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.cyber-cta button:hover {\r\n  background-color: #25402d;\r\n}\r\n.cyber-topics-grid-section {\r\n  background-color: #224D36; /* Deep green */\r\n  padding: 60px 20px;\r\n  color: white;\r\n  text-align: center;\r\n}\r\n\r\n.topics-heading {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.topics-columns {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 60px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.topics-columns ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  text-align: left;\r\n}\r\n\r\n.topics-columns li {\r\n  margin-bottom: 12px;\r\n  position: relative;\r\n  padding-left: 24px;\r\n}\r\n\r\n.topics-columns li::before {\r\n  content: \"✔\";\r\n  position: absolute;\r\n  left: 0;\r\n  color: #A1F0DC; /* Light green icon */\r\n  font-size: 14px;\r\n}\r\n.cyber-topics-grid-section {\r\n  background-color: #ffffff;\r\n  color: rgb(17, 17, 17);\r\n  padding: 60px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.topics-heading {\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.topics-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr); /* 👈 Four equal-width columns */\r\n  gap: 20px;\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  text-align: left;\r\n}\r\n\r\n.topic-item {\r\n  background-color: rgba(120, 196, 120, 0.05);\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  height: 100px;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 15px;\r\n}\r\n\r\n.check-icon {\r\n  color: #A1F0DC;\r\n  font-size: 16px;\r\n}\r\n.topic-item {\r\n  background-color: rgba(120, 196, 120, 0.05);\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100px;\r\n  gap: 12px;\r\n  font-size: 16px;\r\n  transition: background 0.3s ease;\r\n}\r\n\r\n.topic-item:hover {\r\n  background-color: rgba(47, 77, 56, 0.1);\r\n}\r\n\r\n.check-icon {\r\n  font-size: 30px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n\r\n.cyber-learning-compliance {\r\n  background-color: #fff;\r\n  padding:40px;\r\n  /* max-width: 1100px; */\r\n  /* margin: 0 auto; */\r\n}\r\n\r\n.learning-block {\r\n  background-color: #f5fdfb;\r\n  border-left: 6px solid #2F4D38;\r\n  border-radius: 10px;\r\n  padding: 30px;\r\n  margin-bottom: 40px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.learning-block h3 {\r\n  font-size: 22px;\r\n  color: #2F4D38;\r\n  margin-bottom: 15px;\r\n  font-weight: 600;\r\n}\r\n\r\n.learning-block p {\r\n  color: #333;\r\n  font-size: 15px;\r\n  line-height: 1.7;\r\n}\r\n.cyber-benefits-redesign {\r\n  background-color: #f9fdfb;\r\n  padding: 60px 20px;\r\n}\r\n\r\n.benefits-content {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n  gap: 40px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  align-items: center;\r\n}\r\n\r\n.benefits-list {\r\n  flex: 1;\r\n}\r\n\r\n.benefits-list h3 {\r\n  font-size: 24px;\r\n  color: #2F4D38;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.benefit-items {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 16px;\r\n}\r\n\r\n.benefit-card {\r\n  background: #ffffff;\r\n  border-left: 5px solid #2F4D38;\r\n  padding: 14px 18px;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.benefit-icon {\r\n  color: #2F4D38;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n  margin-top: 2px;\r\n}\r\n\r\n.benefit-card p {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 15px;\r\n}\r\n\r\n.benefits-image {\r\n  flex: 1;\r\n  text-align: center;\r\n}\r\n\r\n.benefits-image img {\r\n  max-width: 300px;\r\n  width: 100%;\r\n  height: auto;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.breach-highlight {\r\n  background-color: #e6f5f0;\r\n  color: #1c3c2e;\r\n  padding: 12px 16px;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* Bottom CTA */\r\n.bottom-cta {\r\n  background-color: #2F4D38;\r\n  color: white;\r\n  text-align: center;\r\n  padding: 4rem 1rem;\r\n}\r\n\r\n.bottom-cta .cta-container {\r\n  max-width: 40rem;\r\n  margin: 0 auto;\r\n}\r\n\r\n.bottom-cta h3 {\r\n  font-size: 1.25rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.bottom-cta p {\r\n  font-size: 1.125rem;\r\n  margin: 1rem 0;\r\n}\r\n\r\n.bottom-cta button {\r\n  background-color: white;\r\n  color: #2F4D38;\r\n  padding: 0.5rem 1.5rem;\r\n  font-weight: 500;\r\n  border: none;\r\n  border-radius: 9999px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.bottom-cta button:hover {\r\n  background-color: #f0f0f0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
